import {IEnumListEntry} from "../definitions";
export const SOURCE_TYPES = {
    SPELL: 0,
    DECOR: 1,
    BUFF: 2,
    PAYED_ACCELERATE: 3,
    TUTOR_ACCELERATE: 4
};


export const SOURCE_TYPES_LIST:IEnumListEntry[] = [
    { id: SOURCE_TYPES.SPELL, label: "SPELL" },
    { id: SOURCE_TYPES.DECOR, label: "DECOR" },
    { id: SOURCE_TYPES.BUFF, label: "BUFF" },
    { id: SOURCE_TYPES.PAYED_ACCELERATE, label: "PAYED ACCELERATE" },
    { id: SOURCE_TYPES.TUTOR_ACCELERATE, label: "TUTOR ACCELERATE" }
];



// WEBPACK FOOTER //
// /opt/app/develop/src/app/enums/e-sources.ts